import { competitionListTimeEnum } from "app/utils/const";
import type { EventType } from "../../../../../../types/eventType";
import AsianEventMarketPlaceholder from "../AsianEventMarketPlaceholder/AsianEventMarketPlaceholder";
import "./AsianEventMarketHandicapContainer.scss";
import AsianEventMarketHandicap from "./components/AsianEventMarketHandicap";

type Props = {
  event: EventType;
  addBetSlip: (...args: Array<any>) => any;
  markets: Record<string, any>;
  highestNumberOfMarkets: number;
  line: string;
};

const AsianEventMarketHandicapContainer = (props: Props): React.JSX.Element => {
  const { markets, event, addBetSlip, highestNumberOfMarkets, line } = props;

  const dummyOdds = Array.from(
    { length: highestNumberOfMarkets - markets.length },
    (_, i) => (
      <div
        className="asian-marketType-container__handicap--dummy"
        key={i}
      ></div>
    )
  );

  return (
    <>
      <div className="asian-marketType-container__handicap">
        {markets &&
          markets.map((market, index) => {
            if (!market.runners) {
              return (
                <AsianEventMarketPlaceholder
                  marketId={market?.id}
                  line={line}
                />
              );
            } else {
              return (
                <div
                  className={`asian-market-outer-container ${
                    line === competitionListTimeEnum.ALL ? "all-view" : ""
                  }`}
                  key={market.id}
                >
                  {market.runners !== undefined &&
                    market.runners.length >= 1 && (
                      <AsianEventMarketHandicap
                        market={market}
                        addBetSlip={addBetSlip}
                        event={event}
                      />
                    )}
                  {index === 0 && <div className="asian-events-spacer"></div>}
                </div>
              );
            }
          })}
        {dummyOdds}
      </div>
    </>
  );
};

export default AsianEventMarketHandicapContainer;
